import { ICredential, IUtility } from 'common/src/types/interfaces';

import {
  autoCompleteType,
  passwordInputType,
  textInputType,
} from '../../../common/forms/FormFieldTypes';

export type CredentialFormValues = ReturnType<typeof defaultValues>;

export const defaultValues = (entity: Partial<ICredential> = {}) => ({
  utilityId: entity.utilityId ?? '',
  loginUrl: entity.loginUrl ?? '',
  username: entity.username ?? '',
  password: entity.password ?? '',
});

export const getCredentialFormFields = (
  utilities: IUtility[],
  isNewForm: boolean,
) => {
  const formFieldsConfiguration: Array<
    textInputType | autoCompleteType | passwordInputType
  > = [
    {
      placeholder: 'Utility',
      label: 'Utility',
      name: 'utilityId',
      type: 'autocomplete',
      required: true,
      options: utilities.map((item) => ({
        label: item.name,
        value: item.id,
        key: item.id,
        disabled: !item.isActive,
      })),
    },
    {
      placeholder: 'Login URL',
      label: 'Login URL',
      name: 'loginUrl',
      type: 'textInput',
      required: true, // Not required server-side
    },
    {
      placeholder: 'Username',
      label: 'Username',
      name: 'username',
      type: 'textInput',
      required: true,
    },
    {
      placeholder: 'Password',
      label: 'Password',
      name: 'password',
      type: 'password',
      hidden: !isNewForm,
      required: isNewForm,
    },
  ];

  return formFieldsConfiguration;
};
